<template>
  <div class="grid content-start gap-5">
    <div class="grid gap-2">
      <div class="flex space-x-1 items-center">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <Icon v-bind="props" icon="ant-design:info-circle" class="text-xl cursor-pointer" />
          </template>
          <div class="w-40 whitespace-normal text-center">
            Use your mouse to highlight the text you want to paraphrase. Then, click the
            "Paraphrase" button.
          </div>
        </v-tooltip>
        <span class="font-semibold text-sm 2xl:text-base"
          >Select text to paraphrase in the document</span
        >
      </div>
    </div>

    <div class="w-full">
      <v-btn
        :disabled="loadingBrainResponse || !selectedText"
        :loading="loadingBrainResponse"
        @click="paraphraseText"
        variant="flat"
        class="!py-3 w-full !bg-primary-main !ml-auto !mx-5 !rounded-xl !tracking-normal !capitalize !text-white !h-auto"
      >
        Paraphrase
      </v-btn>
      <small>Please limit your request to 8000 characters</small>
    </div>

    <div class="grid gap-2">
      <div class="flex space-x-1 items-center">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <Icon v-bind="props" icon="ant-design:info-circle" class="text-xl cursor-pointer" />
          </template>
          <div class="w-40 whitespace-normal text-center">
            The paraphrased text will appear below.
          </div>
        </v-tooltip>
        <span class="font-semibold text-sm 2xl:text-base">Paraphrased text</span>
      </div>
      <div
        class="w-full grid gap-2 flex-1 bg-white rounded-md p-5 pl-7 h-96 overflow-y-auto overflow-x-hidden"
      >
        <div class="whitespace-normal w-full break-words break-all">
          {{ paraphrasedText }}
        </div>
      </div>
    </div>

    <v-btn
      :disabled="!!!paraphrasedText"
      @click="insertSentence(paraphrasedText)"
      variant="flat"
      class="!py-3 w-full !bg-primary-main !ml-auto !mx-5 !rounded-xl !tracking-normal !capitalize !text-white !h-auto"
    >
      Insert Text
    </v-btn>

    <!--<v-btn
      :disabled="!!!paraphrasedText"
      @click="tryAgain"
      variant="flat"
      class="!py-3 w-full !bg-primary-white !ml-auto !mx-5 !rounded-xl !tracking-normal !capitalize !text-black !h-auto"
    >
      Try Again
    </v-btn> -->
  </div>
</template>

<script lang="ts">
import TlTextArea from '@/components/global/TlTextArea.vue';
import TlTextField from '@/components/global/TlTextField.vue';
import { Icon } from '@iconify/vue';
import { Vue, Options } from 'vue-class-component';
import { usePayloadStore } from '@/stores/payload';
import { Prop, Watch } from 'vue-property-decorator';

@Options({
  components: {
    TlTextArea,
    TlTextField,
    Icon
  }
})
export default class Paraphraser extends Vue {
  @Prop()
  public selectedText!: string;

  @Prop()
  public paraphrasedText!: string;

  private payloadStore = usePayloadStore();
  public loadingBrainResponse = this.payloadStore.payload.loadingBrainResponse;

  @Watch('payloadStore.payload')
  public onLoadingBrainResponse() {
    this.loadingBrainResponse = this.payloadStore.payload.loadingBrainResponse;
  }
  public paraphraseText() {
    this.$emit('paraphraseText');
  }

  public tryAgain() {
    this.$emit('tryAgain');
  }

  public insertSentence(sentence: string) {
    this.$emit('insertSentence', sentence);
  }
}
</script>
